import { useAgents } from '@/store/agents';

type PromptAgentAvatarProps = {
  /** The agent's id, as in `PROMPT_AGENT_IDS`. */
  agentId: number;
  size?: number;
};

/**
 * An agent's real avatar beside its name on a prompt's agent chips. Until the
 * agents list loads (or when an agent has no avatar) it keeps an empty circle
 * the same size, so the chip does not change width.
 */
export function PromptAgentAvatar({
  agentId,
  size = 20,
}: PromptAgentAvatarProps) {
  const { data: agents } = useAgents();
  const agent = agents?.find(item => item.id === agentId);
  const url = agent?.avatar?.url;

  return url ? (
    <img
      className='prompt-agent-avatar'
      src={url}
      alt=''
      aria-hidden='true'
      width={size}
      height={size}
      style={{ width: size, height: size }}
      data-cy='prompt-agent-avatar'
    />
  ) : (
    <span
      className='prompt-agent-avatar'
      aria-hidden='true'
      style={{ width: size, height: size }}
    />
  );
}
